import { auth, invoiceBaseURL } from "../Utility";
import axios from 'axios'

// invoice
export const invoiceAxiosInstance = axios.create({
baseURL: 'https://invoice.itworkshop.in/', 
  headers: { 'Content-Type': 'application/json' },
});

// interceptors invoice
invoiceAxiosInstance.interceptors.request.use(
  (config) => {
    // Don't override if custom token is already set in headers
    if (!config.headers.Authorization) {
      const token = getAdminToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// only admin
function getAdminToken() {
  return auth("admin")?.token;
}

// Updated INVOICE_APICALL to accept custom token
export const INVOICE_APICALL = async (endPoint = '', method = "GET", value = null, customToken = null) => {
  try {
    const config = {
      method: method,
      url: endPoint,
      data: value,
    };
    
    // If custom token provided, add it to headers
    if (customToken) {
      config.headers = {
        'Authorization': `Bearer ${customToken}`,
        'Content-Type': 'application/json'
      };
    }
    
    const response = await invoiceAxiosInstance(config);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};